import React, { useState } from "react";
import * as dmsService from "../../../services/dmsService";
import useFinOptions from "../../Fin/useFinOptions";
import { hint, linkBtn } from "../../Fin/gl/glUi";
import { DmsBadge, run } from "../sales/dmsUi";
import { AppDropdown, EmptyState, LoadState, PageHeader, SecondaryButton, cardStyle, formatDateTime, pageStyle, useLoad } from "../../../components/ui";

// Technician Board: each technician's open jobs, who is clocked on where, and today's
// efficiency (hours sold on finished jobs / hours clocked). Technicians clock on and off here.
export default function TechnicianBoard() {
  const fin = useFinOptions(["locations"]);
  const [loc, setLoc] = useState(null);
  const { data, loading, error, reload } = useLoad(() => dmsService.technicianBoard({ location_id: loc || undefined }), [loc]);
  const clock = (job, action, technicianId) => run(() => dmsService.jobAction(job.ro_id, job.id, action, technicianId ? { technician_employee_id: technicianId } : {}), reload);
  return (
    <div style={pageStyle}>
      <PageHeader title="Technician Board" subtitle="Open jobs by technician, clocking and today's efficiency" actions={<SecondaryButton onClick={reload}>Refresh</SecondaryButton>} />
      <div style={{ ...hint, marginBottom: 12 }}>
        This board shows the jobs on workshop repair orders. Steps of a booking's workflow (drop-off, cleaning, pick-up and so on) stay under Tasks.
      </div>
      <div className="mb-3" style={{ width: 260 }}>
        <AppDropdown id="tb-loc" value={loc} options={[{ label: "All workshops", value: null }, ...(fin.locations || [])]} onChange={(e) => setLoc(e.value)} />
      </div>
      <LoadState loading={loading} error={error} onRetry={reload}>
        {(data || []).length === 0 ? <EmptyState title="No open jobs" /> : null}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
          {(data || []).map((lane) => (
            <div key={lane.technician_name} style={{ ...cardStyle, padding: 14 }}>
              <div className="d-flex justify-content-between align-items-baseline">
                <h6 className="mb-1">{lane.technician_name}</h6>
                {lane.efficiency_today !== null ? <span style={{ fontSize: 13, fontWeight: 600, color: lane.efficiency_today >= 100 ? "#065F46" : "#92400E" }}>{lane.efficiency_today}% today</span> : null}
              </div>
              <div style={hint}>
                {lane.clocked_on_job ? `On ${lane.clocked_on_job.ro_number} job ${lane.clocked_on_job.job_no} since ${formatDateTime(lane.clocked_since)}` : "Not clocked on"} · {Math.round(lane.minutes_today / 6) / 10} h clocked today
              </div>
              {lane.jobs.length === 0 ? <div style={{ ...hint, marginTop: 8 }}>No open jobs.</div> : null}
              {lane.jobs.map((j) => {
                const onIt = lane.clocked_on_job && lane.clocked_on_job.ro_number === j.ro_number && lane.clocked_on_job.job_no === j.job_no;
                return (
                  <div key={`${j.ro_number}-${j.job_no}`} style={{ borderTop: "1px solid #E5E7EB", marginTop: 8, paddingTop: 8, fontSize: 14 }}>
                    <div className="d-flex justify-content-between gap-2">
                      <b>
                        {j.ro_number} · job {j.job_no}
                      </b>
                      <DmsBadge status={j.status} />
                    </div>
                    <div>{j.complaint}</div>
                    <div style={hint}>
                      {j.plate_no || ""} {j.vehicle_desc || ""} · {Number(j.sold_hours)} h sold{j.promised_at ? ` · promised ${formatDateTime(j.promised_at)}` : ""}
                    </div>
                    {lane.technician_employee_id ? (
                      <button type="button" style={linkBtn} onClick={() => clock(j, onIt ? "clock-off" : "clock-on", lane.technician_employee_id)}>
                        {onIt ? "Clock off" : "Clock on"}
                      </button>
                    ) : (
                      <span style={hint}>Assign a technician on the repair order</span>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </LoadState>
    </div>
  );
}
